import './style/index.js';

import _QRCode from './QRCode';

export type { QrCodeProps } from './QRCode';
export * from './type';

export const QRCode = _QRCode;
export default QRCode;
